import { isValidPhoneNumber } from 'libphonenumber-js';
import { z } from 'zod';

import type { PhoneFieldSchemaOptions } from './types';

export function phoneFieldSchema({
	required = false,
	invalidMessage = 'Invalid phone number format'
}: PhoneFieldSchemaOptions = {}) {
	return z
		.string()
		.transform((v) => (typeof v === 'string' ? v.trim() : ''))
		.refine((v) => !required || v.length > 0, {
			message:
				typeof required === 'string' ? required : 'Phone number is required'
		})
		.refine((v) => v.length === 0 || isValidPhoneNumber(v), {
			message: invalidMessage
		});
}
